import React, { useState } from "react";
import Index from "../AirSearch/Index"

const AuthPage = ({ onLoginSuccess }) => { 
  const [isActive, setIsActive] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false); 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  
  // --- STATES FOR LOGGED IN USER ---
  const [userData, setUserData] = useState(null); 
  const [showDropdown, setShowDropdown] = useState(false);

  // --- LOGIN HANDLER ---
  const handleLogin = async (e) => {
    e.preventDefault();
    setApiMessage(""); 

  debugger;
    const payload = {
      AgencyCode: null,
      UserEmail: email,
      UserName: null,
      LastName: null,
      DOB: null,
      UserMobile: null,
      UserPassword: password,
      UserKey: null,
      UserStatus: null,
      ApiStatus: 0,
      ApiMessage: null,
      ApiResponse: null,
      ApiErro: null,
      AgencyKey: "02AD68F3-9AE6-4148-85B1-E61D1F03991F",
      AccountNo: 11
    };

    try {
const apiUrl = process.env.REACT_APP_API_LOGIN_URL;

      if (!apiUrl) {
        throw new Error("API URL missing! Please check your .env file and restart terminal.");
      }

      console.log("🔐 Login Request URL:", apiUrl);
      console.log("📨 Sending Payload:", JSON.stringify(payload, null, 2));

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload),
      });
debugger;
      console.log("📥 Response Status:", response.status);
      console.log("📥 Response Headers:", response.headers);

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();
      console.log("✅ API Response Complete:", JSON.stringify(data, null, 2));

      // ✅ CHECK: UserStatus should be "Valid" and UserKey should exist
      if (data && data.UserStatus === "Valid" && data.UserKey) {
        setIsSuccess(true);
        setUserData(data); 
        setApiMessage("✅ Login Successful!");
        localStorage.setItem("userKey", data.UserKey);
        localStorage.setItem("userData", JSON.stringify(data));

        console.log("✅ LOGIN SUCCESS:", data);

        if (onLoginSuccess) {
          onLoginSuccess(data);
        }
      } else {
        setIsSuccess(false);
        
        // ✅ Better error message - check different response fields
        let errorMsg = "Login failed: Invalid credentials";
        
        if (data?.ApiMessage) {
          errorMsg = data.ApiMessage;
        } else if (data?.message) {
          errorMsg = data.message;
        } else if (data?.error) {
          errorMsg = data.error;
        }
        
        setApiMessage("❌ " + errorMsg);
        console.error("❌ LOGIN FAILED:", {
          userStatus: data?.UserStatus,
          userKey: data?.UserKey,
          apiMessage: data?.ApiMessage,
          fullResponse: data
        });
      }
    } catch (error) {
      console.error("❌ FETCH ERROR:", error.message);
      setIsSuccess(false);
      
      if (error.message.includes("Failed to fetch")) {
        setApiMessage("❌ Network error! Check your internet connection.");
      } else if (error.message.includes("HTTP")) {
        setApiMessage(`❌ Server error: ${error.message}`);
      } else {
        setApiMessage("❌ " + error.message);
      }
    }
  };

  // --- LOGOUT HANDLER ---
  const handleLogout = () => {
    setIsSuccess(false);
    setUserData(null);
    setEmail("");
    setPassword("");
    setApiMessage("");
    setShowDropdown(false);
    localStorage.removeItem("userKey");
    localStorage.removeItem("userData");
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght=300;400;600&display=swap');
        @import url('https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: "Poppins", sans-serif;
        }

        body, .page-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: linear-gradient(90deg, #e2e2e2, #c9d6ff);
        }

        .container {
          position: relative;
          width: 1000px;
          height: 550px;
          background: #fff;
          margin: 20px;
          border-radius: 30px;
          box-shadow: 0 0 30px rgba(0, 0, 0, .2);
          overflow: hidden;
          transition: 0.6s ease-in-out;
        }

        .container h1 { font-size: 36px; margin: -10px 0; }
        .container p { font-size: 14.5px; margin: 15px 0; }

        form { width: 100%; }

        .form-box {
          position: absolute;
          right: 0;
          width: 50%;
          height: 100%;
          background: #fff;
          display: flex;
          align-items: center;
          color: #333;
          text-align: center;
          padding: 40px;
          z-index: 1;
          transition: .6s ease-in-out 1.2s, visibility 0s 1s;
        }

        .container.active .form-box { right: 50%; }

        .form-box.register { visibility: hidden; }
        .container.active .form-box.register { visibility: visible; }

        .input-box {
          position: relative;
          margin: 30px 0;
        }

        .input-box input {
          width: 100%;
          padding: 13px 50px 13px 20px;
          background: #eee;
          border-radius: 8px;
          border: none;
          outline: none;
          font-size: 16px;
          color: #333;
          font-weight: 500;
          transition: 0.3s;
        }

        .input-box input:focus {
          background: #fff;
          border: 2px solid #0a2a6e;
        }

        .input-box i {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 20px;
        }

        .btn {
          width: 100%;
          height: 48px;
          background: #0a2a6e;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          font-size: 16px;
          color: #fff;
          font-weight: 600;
          margin-top: 10px;
          transition: 0.3s;
        }

        .btn:hover {
          background: #082050;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(10, 42, 110, 0.3);
        }

        .btn:active {
          transform: translateY(0);
        }

        .social-icons {
          display: flex;
          justify-content: center;
          margin-top: 15px;
        }

        .social-icons a {
          display: inline-flex;
          padding: 10px;
          border: 2px solid #ccc;
          border-radius: 8px;
          font-size: 24px;
          color: #333;
          margin: 0 8px;
          text-decoration: none;
          transition: 0.3s;
        }

        .social-icons a:hover {
          border-color: #0a2a6e;
          color: #0a2a6e;
        }

        .toggle-box {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        .toggle-box::before {
          content: '';
          position: absolute;
          left: -250%;
          width: 300%;
          height: 100%;
          background: #0a2a6e;
          border-radius: 150px;
          z-index: 2;
          transition: 1.8s ease-in-out;
        }

        .container.active .toggle-box::before { left: 50%; }

        .toggle-panel {
          position: absolute;
          width: 50%;
          height: 100%;
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 2;
          transition: .6s ease-in-out;
        }

        .toggle-panel.toggle-left { left: 0; transition-delay: 1.2s; }
        .container.active .toggle-panel.toggle-left { left: -50%; transition-delay: .6s; }

        .toggle-panel.toggle-right { right: -50%; transition-delay: .6s; }
        .container.active .toggle-panel.toggle-right { right: 0; transition-delay: 1.2s; }

        .toggle-panel p { margin-bottom: 20px; }
        .toggle-panel .btn {
          width: 160px;
          height: 46px;
          background: transparent;
          border: 2px solid #fff;
          box-shadow: none;
        }
        
        .msg-text {
          font-weight: 600;
          margin-top: 15px !important;
          font-size: 14px;
          min-height: 20px;
        }

        .msg-text.success {
          color: #4caf50;
        }

        .msg-text.error {
          color: #d32f2f;
        }

        .profile-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          position: relative;
        }

        .profile-container {
          position: relative;
          cursor: pointer;
          text-align: center;
        }

        .avatar-icon {
          font-size: 80px;
          color: #0a2a6e;
          background: #eee;
          padding: 15px;
          border-radius: 50%;
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
          transition: 0.3s;
        }

        .avatar-icon:hover {
          transform: scale(1.05);
        }

        .dropdown-menu {
          position: absolute;
          top: 130px;
          left: 50%;
          transform: translateX(-50%);
          background: #fff;
          width: 280px;
          border-radius: 15px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          padding: 20px;
          text-align: left;
          z-index: 10;
          border: 1px solid #eee;
          animation: slideDown 0.3s ease-out;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }

        .dropdown-menu h3 {
          font-size: 18px;
          color: #0a2a6e;
          margin-bottom: 5px;
          border-bottom: 2px solid #f0f0f0;
          padding-bottom: 8px;
        }

        .dropdown-menu p {
          font-size: 13.5px;
          color: #555;
          margin: 8px 0 !important;
          word-break: break-all;
        }

        .dropdown-menu p i {
          margin-right: 8px;
          color: #0a2a6e;
        }

        .logout-btn {
          width: 100%;
          background: #d32f2f;
          margin-top: 15px;
          height: 40px;
        }
        
        .logout-btn:hover {
          background: #b71c1c;
          transform: translateY(-2px);
        }
      `}</style>

      <div className={`container ${isActive ? "active" : ""}`}>
        {isSuccess ? (
          <div className="profile-wrapper">
            <div className="profile-container" onClick={() => setShowDropdown(!showDropdown)}>
              <i className="bx bxs-user-circle avatar-icon"></i>
              <p style={{ fontWeight: '600', marginTop: '10px', color: '#0a2a6e' }}>
                Hi, {userData?.UserName || "User"} 👋
              </p>

              {showDropdown && (
                <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                  <h3>Account Details</h3>
                  <p><i className="bx bxs-user"></i> <b>Name:</b> {userData?.UserName || "N/A"}</p>
                  <p><i className="bx bxs-envelope"></i> <b>Email:</b> {email}</p>
                  <p><i className="bx bxs-key"></i> <b>Status:</b> {userData?.UserStatus}</p>
                  <p><i className="bx bxs-id-card"></i> <b>Account:</b> {userData?.AccountNo || "11"}</p>
                  <p><i className="bx bxs-key"></i> <b>Key:</b> {userData?.UserKey?.substring(0, 20)}...</p>
                  
                  <button className="btn logout-btn" onClick={handleLogout}>
                    <i className="bx bx-log-out" style={{ marginRight: '5px' }}></i> Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            <div className="form-box login">
              <form onSubmit={handleLogin}>
                <h1>Login</h1>
                <div className="input-box">
                  <input
                    type="email"
                    placeholder="Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <i className="bx bxs-user"></i>
                </div>
                <div className="input-box">
                  <input
                    type="password"
                    placeholder="Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <i className="bx bxs-lock-alt"></i>
                </div>
                <button type="submit" className="btn">Login</button>

                {apiMessage && (
                  <p className={`msg-text ${apiMessage.includes("✅") ? "success" : "error"}`}>
                    {apiMessage}
                  </p>
                )}
              </form>
            </div>

            <div className="form-box register">
              <form onSubmit={(e) => e.preventDefault()}>
                <h1>Registration</h1>
                <div className="input-box">
                  <input type="text" placeholder="Username" required />
                  <i className="bx bxs-user"></i>
                </div>
                <div className="input-box">
                  <input type="email" placeholder="Email" required />
                  <i className="bx bxs-envelope"></i>
                </div>
                <div className="input-box">
                  <input type="password" placeholder="Password" required />
                  <i className="bx bxs-lock-alt"></i>
                </div>
                <button type="submit" className="btn">Register</button>
                <p>or register with social platforms</p>
                <div className="social-icons">
                  <a href="#"><i className="bx bxl-google"></i></a>
                  <a href="#"><i className="bx bxl-facebook"></i></a>
                  <a href="#"><i className="bx bxl-github"></i></a>
                  <a href="#"><i className="bx bxl-linkedin"></i></a>
                </div>
              </form>
            </div>  

            <div className="toggle-box">
              <div className="toggle-panel toggle-left">
                <h1>Hello, Welcome!</h1>
                <p>Don't have an account?</p>
                <button className="btn" onClick={() => setIsActive(true)}>Register</button>
              </div>

              <div className="toggle-panel toggle-right">
                <h1>Welcome Back!</h1>
                <p>Already have an account?</p>
                <button className="btn" onClick={() => setIsActive(false)}>Login</button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AuthPage;